// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"303":"0db7aa79","679":"4756d2d2"}[chunkId] + ".css";
};